// @ts-check

import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';


import React from "react";
import ReactDOM from "react-dom";

import App from "./components/App";
import './Index.css';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import * as serviceWorker from "./serviceWorker";
import { store } from './_helpers';
import { Provider } from 'react-redux';
import 'font-awesome/css/font-awesome.min.css';

ReactDOM.render(

  <Provider store={store}>
    <ToastContainer />
    <App />
  </Provider>

  , document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
